import axios from 'axios';
import config from 'config'

const state = {
    // Borse sättas till null!
    Draft: { AccountId: "1910", SwedishName: "Kassa", IsDeleted: false, IsBasic: false },
    Current: { AccountId: "1910", SwedishName: "Kassa", IsDeleted: false, IsBasic: false },
}

const getters = {
    data(state) {
        return state
    }
}

const mutations = {
    SET_DRAFT(state, values) {
        //console.log('Set draft');
        state.Draft = values;
    },

 
    SET_DRAFT_AND_CURRENT(state, values) {
        //console.log('Got Draft and Current from database');

        state.Draft = values.Draft;
        state.Current = values.Current;
    }
}

const actions = {
    saveDraft({ commit }, payload) {
        //console.log('saveDraft');
        axios.post(`${config.apiUrl}/internal/account/` + payload.id, payload.draft, { headers: { 'Content-Type': 'application/json' } })
            .then((response) => {
                commit('SET_DRAFT', payload.draft);
            }, (error) => {
                console.log(error);
            });
    },

    getAccount({ commit }, payload) {
        //console.log('getAccount id:' + payload.id);

        return new Promise((resolve, reject) => {
            axios.get(`${config.apiUrl}/internal/account/` + payload.id, { headers: { 'Accept': 'application/json' } })
                .then(response => {
                    //console.log('axios.get response');

                    commit('SET_DRAFT_AND_CURRENT', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        })
    
    },


}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
